import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ss_token");
    if (!token) {
      setUser(false);
      return;
    }

    try {
      // SEM barra no final: o backend expõe "/auth/me" (sem "/"). Com a
      // barra, essa chamada sempre dava 404 e o catch abaixo deslogava o
      // usuário todo F5 — mesmo com o token ainda válido.
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
    } catch {
      localStorage.removeItem("ss_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login/", {
      email,
      password,
    });

    localStorage.setItem("ss_token", data.token);
    setUser(data.user);
    setCompany(data.company);

    return data;
  };

  const signupCompany = async (payload) => {
    // SEM barra no final — o backend expõe "/auth/signup-company".
    const { data } = await api.post("/auth/signup-company", payload);

    localStorage.setItem("ss_token", data.token);
    setUser(data.user);
    setCompany(data.company);

    return data;
  };

  const signupInvite = async (payload) => {
    // SEM barra no final — o backend expõe "/auth/signup-invite".
    const { data } = await api.post("/auth/signup-invite", payload);
    return data;
  };

  const logout = async () => {
    try {
      // SEM barra no final — o backend expõe "/auth/logout".
      await api.post("/auth/logout");
    } catch (_e) {
      // ignora erro de logout
    }

    localStorage.removeItem("ss_token");
    setUser(false);
    setCompany(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        company,
        login,
        signupCompany,
        signupInvite,
        logout,
        refresh: loadMe,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);